// import { useAuth } from 'context/auth'
// import React from 'react'
// import { Link } from 'react-router-dom'

// function Plan() {
//   const { currentUser } = useAuth()

//   // Get limit from dynamic planData or use default
//   const getLimit = () => {
//     if (currentUser.account.planData) {
//       const limit = currentUser.account.planData.notifications
//       return limit === -1 ? Infinity : limit
//     }
//     return 2 // Default free plan limit
//   }

//   const limit = getLimit()
//   const notifications = currentUser.account.usage?.notifications || 0

//   const getUsagePercentage = () => {
//     if (limit === Infinity) return '0%'
//     const percentage = (notifications / limit) * 100
//     if (percentage > 100) return '100%'
//     return percentage + '%'
//   }

//   return (
//     <div className='tw-flex tw-flex-col tw-w-[200px] tw-justify-center tw-max-w-full sm:tw-mr-5 tw-mb-8 sm:tw-mb-0 tw-mt-3 sm:tw-mt-0'>
//       <div className='tw-text-gray-800 tw-text-sm tw-flex tw-justify-between tw-mb-1'>
//         <span className='tw-flex tw-justify-start'>
//           <Link className='hover:tw-underline' to='/cardholders'>
//             Notifications
//           </Link>
//         </span>
//         <span className='tw-flex tw-justify-end'>
//           {limit === Infinity ? notifications : notifications + '/' + limit}
//         </span>
//       </div>
//       <div className='tw-w-full tw-relative'>
//         <div className='tw-bg-line tw-w-full tw-h-2 tw-rounded-sm tw-absolute'></div>
//         <div
//           className='tw-bg-mint tw-h-2 tw-rounded-sm tw-absolute'
//           style={{ width: getUsagePercentage() }}
//         ></div>
//       </div>
//       <div className='tw-w-full tw-mt-3 tw-text-right'>
//         <Link
//           className='tw-block tw-text-electricGreen hover:tw-underline tw-text-sm'
//           to='/subscribe'
//         >
//           Manage subscription ➔
//         </Link>
//       </div>
//     </div>
//   )
// }

// export default Plan

import { useAuth } from 'context/auth'
import React from 'react'
import { Link } from 'react-router-dom'

function Plan({ compact = false }) {
  const { currentUser } = useAuth()

  const getLimit = () => {
    if (currentUser?.account?.planData) {
      const limit = currentUser.account.planData.notifications
      return limit === -1 ? Infinity : limit
    }
    return 2
  }

  const limit = getLimit()
  const notifications = currentUser?.account?.usage?.notifications || 0

  const getUsagePercentage = () => {
    if (limit === Infinity) return '0%'
    const percentage = (notifications / limit) * 100
    return Math.min(percentage, 100) + '%'
  }

  return (
    <div
      className={`tw-w-full tw-flex tw-flex-col ${
        compact ? '' : 'sm:tw-w-[200px] tw-mb-6 sm:tw-mb-0'
      }`}
    >
      <div className="tw-text-ink tw-text-sm tw-flex tw-justify-between tw-mb-1">
        <Link className="tw-whitespace-nowrap hover:tw-underline" to="/broadcast">
          Notifications
        </Link>
        <span className="tw-whitespace-nowrap">
          {limit === Infinity ? notifications : `${notifications}/${limit}`}
        </span>
      </div>

      <div className="tw-w-full tw-h-2 tw-bg-line tw-rounded-sm tw-overflow-hidden">
        <div
          className="tw-h-full tw-bg-ember"
          style={{ width: getUsagePercentage() }}
        />
      </div>

      {!compact && (
        <div className="tw-w-full tw-mt-2 sm:tw-text-right tw-text-left">
          <Link
            className="tw-text-emberText tw-text-sm tw-whitespace-nowrap"
            to="/subscribe"
          >
            Manage subscription →
          </Link>
        </div>
      )}
    </div>
  )
}

export default Plan
